var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "functions-tab" },
    [
      _c("div", { staticClass: "tab-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.functions")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("voiceagent.manageAgentFunctions")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c("div", { staticClass: "functions-section" }, [
          _c(
            "div",
            { staticClass: "section-header" },
            [
              _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.functions")))]),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.create"] } },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", icon: "add" },
                      on: { click: _vm.showAddTool },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("voiceagent.addFunction")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.tools && _vm.tools.length > 0
            ? _c(
                "div",
                { staticClass: "tools-list" },
                [
                  _c("a-table", {
                    attrs: {
                      columns: _vm.toolColumns,
                      "data-source": _vm.tools,
                      pagination: false,
                      loading: _vm.tableLoading,
                      rowKey: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "type",
                          fn: function (text, record) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getToolTypeText(record.type))
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c(
                                "div",
                                { staticClass: "actions" },
                                [
                                  _c("SupsisButton", {
                                    attrs: {
                                      icon: "visibility",
                                      small: "",
                                      ghost: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewTool(record)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "PermissionController",
                                    {
                                      attrs: {
                                        permissions: ["voice-agent.update"],
                                      },
                                    },
                                    [
                                      _c("SupsisButton", {
                                        attrs: {
                                          icon: "edit",
                                          small: "",
                                          ghost: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editTool(record)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "PermissionController",
                                    {
                                      attrs: {
                                        permissions: ["voice-agent.delete"],
                                      },
                                    },
                                    [
                                      _c("SupsisButton", {
                                        attrs: {
                                          danger: "",
                                          icon: "delete",
                                          small: "",
                                          ghost: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeTool(record)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1854113174
                    ),
                  }),
                ],
                1
              )
            : !_vm.loading
            ? _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c(
                    "a-empty",
                    {
                      attrs: {
                        description: _vm.$t("voiceagent.noFunctionsForAgent"),
                      },
                    },
                    [
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.create"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: { click: _vm.showAddTool },
                            },
                            [_vm._v(_vm._s(_vm.$t("voiceagent.addFunction")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("voiceagent.selectFunctionType"),
            footer: null,
          },
          on: { cancel: _vm.closeToolTypeModal },
          model: {
            value: _vm.showToolTypeModal,
            callback: function ($$v) {
              _vm.showToolTypeModal = $$v
            },
            expression: "showToolTypeModal",
          },
        },
        [
          _c("div", { staticClass: "tool-type-selection" }, [
            _c("div", { staticClass: "tool-type-list" }, [
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("end_call")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call_end"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("End Call"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v("Görüşmeyi sonlandırmak için kullanılır"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("transfer_call")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call_forward"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("Call Transfer"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v(
                        "Görüşmeyi başka bir numaraya aktarmak için kullanılır"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("press_digit")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("dialpad"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("Press Digit (IVR Navigation)"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v(
                        "IVR menülerinde gezinmek için tuş basmak için kullanılır"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("extract_dynamic_variable")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("data_object"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("Extract Dynamic Variable"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v(
                        "Konuşmadan dinamik değişkenler çıkarmak için kullanılır"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("agent_swap")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("swap_horiz"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("Agent Transfer"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v(
                        "Görüşmeyi başka bir ajana aktarmak için kullanılır"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tool-type-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectToolType("custom")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "tool-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("build"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool-info" }, [
                    _c("div", { staticClass: "tool-name" }, [
                      _vm._v("Custom Function"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tool-description" }, [
                      _vm._v("Özel fonksiyon tanımlamak için kullanılır"),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.closeToolTypeModal } }, [
                  _vm._v("İptal"),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "End Call Fonksiyonu", footer: null },
          on: { cancel: _vm.closeEndCallModal },
          model: {
            value: _vm.showEndCallModal,
            callback: function ($$v) {
              _vm.showEndCallModal = $$v
            },
            expression: "showEndCallModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "end-call-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.endCallForm, layout: "vertical" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                initialValue: "end_call",
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                initialValue: 'end_call',\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "end_call" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description (Opsiyonel)" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                initialValue: "End the call with user.",
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                initialValue: 'End the call with user.',\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Fonksiyonun ne yaptığını ve ne zaman çağrılacağını tanımlayın",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeEndCallModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: _vm.endCallSubmitting,
                              },
                              on: { click: _vm.handleEndCallSubmit },
                            },
                            [
                              _vm.endCallSubmitting
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v("autorenew")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                            Kaydet\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Call Transfer Fonksiyonu",
            footer: null,
            width: "800px",
          },
          on: { cancel: _vm.closeTransferCallModal },
          model: {
            value: _vm.showTransferCallModal,
            callback: function ($$v) {
              _vm.showTransferCallModal = $$v
            },
            expression: "showTransferCallModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "transfer-call-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.transferCallForm, layout: "vertical" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                initialValue: "transfer_call",
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                initialValue: 'transfer_call',\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "transfer_call" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description (Opsiyonel)" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                initialValue:
                                  "Transfer the call to another number.",
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                initialValue: 'Transfer the call to another number.',\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Fonksiyonun ne yaptığını ve ne zaman çağrılacağını tanımlayın",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-form-item", { attrs: { label: "Transfer to" } }, [
                    _c(
                      "div",
                      { staticClass: "transfer-destination-options" },
                      [
                        _c(
                          "a-radio-group",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "destination_type",
                                  {
                                    initialValue: "predefined",
                                  },
                                ],
                                expression:
                                  "[\n                                'destination_type',\n                                {\n                                    initialValue: 'predefined',\n                                },\n                            ]",
                              },
                            ],
                            on: { change: _vm.onTransferTypeChange },
                          },
                          [
                            _c("a-radio", { attrs: { value: "predefined" } }, [
                              _vm._v("Static Destination"),
                            ]),
                            _vm._v(" "),
                            _c("a-radio", { attrs: { value: "inferred" } }, [
                              _vm._v("Dynamic Routing"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "number_format",
                                  {
                                    initialValue: "e164",
                                  },
                                ],
                                expression:
                                  "[\n                                'number_format',\n                                {\n                                    initialValue: 'e164',\n                                },\n                            ]",
                              },
                            ],
                            staticStyle: { "min-width": "180px" },
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { value: "e164" } },
                              [_vm._v("Format to E.164")]
                            ),
                            _vm._v(" "),
                            _c("a-select-option", { attrs: { value: "raw" } }, [
                              _vm._v("Keep raw input"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.transferCallForm.getFieldValue("destination_type") ===
                  "predefined"
                    ? _c(
                        "a-form-item",
                        {
                          attrs: { label: "Static Destination", required: "" },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "number",
                                  {
                                    rules: [
                                      {
                                        required:
                                          _vm.transferCallForm.getFieldValue(
                                            "destination_type"
                                          ) === "predefined",
                                        message:
                                          "Transfer edilecek numara gereklidir!",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                            'number',\n                            {\n                                rules: [\n                                    {\n                                        required:\n                                            transferCallForm.getFieldValue('destination_type') === 'predefined',\n                                        message: 'Transfer edilecek numara gereklidir!',\n                                    },\n                                ],\n                            },\n                        ]",
                              },
                            ],
                            attrs: {
                              placeholder:
                                "Enter a static phone number / SIP URI / dynamic variable.",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "transfer-extension-row" },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "has_extension",
                                        {
                                          valuePropName: "checked",
                                          initialValue: false,
                                        },
                                      ],
                                      expression:
                                        "[\n                                'has_extension',\n                                {\n                                    valuePropName: 'checked',\n                                    initialValue: false,\n                                },\n                            ]",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n                            Extension Number\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.transferCallForm.getFieldValue(
                                "has_extension"
                              )
                                ? _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["extension", {}],
                                        expression: "['extension', {}]",
                                      },
                                    ],
                                    staticStyle: { "max-width": "200px" },
                                    attrs: { placeholder: "0000" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "hint-text" }, [
                            _vm._v(
                              "\n                        Enter a static phone number, SIP URI, or dynamic variable (örn: transfer_number değişkeni).\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.transferCallForm.getFieldValue("has_extension")
                            ? _c("div", { staticClass: "hint-text" }, [
                                _vm._v(
                                  "\n                        Extension digits are sent via DTMF after the main number connects.\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.transferCallForm.getFieldValue("destination_type") ===
                  "inferred"
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "Dynamic Routing Prompt",
                            required: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "prompt",
                                  {
                                    rules: [
                                      {
                                        required:
                                          _vm.transferCallForm.getFieldValue(
                                            "destination_type"
                                          ) === "inferred",
                                        message:
                                          "Yönlendirme için prompt gereklidir!",
                                      },
                                    ],
                                    initialValue:
                                      "Kullanıcı destek isterse +1 (925) 222-2222 numarasına yönlendir; satış ekibine ulaşmak isterse +1 (925) 333-3333 numarasına yönlendir",
                                  },
                                ],
                                expression:
                                  "[\n                            'prompt',\n                            {\n                                rules: [\n                                    {\n                                        required: transferCallForm.getFieldValue('destination_type') === 'inferred',\n                                        message: 'Yönlendirme için prompt gereklidir!',\n                                    },\n                                ],\n                                initialValue:\n                                    'Kullanıcı destek isterse +1 (925) 222-2222 numarasına yönlendir; satış ekibine ulaşmak isterse +1 (925) 333-3333 numarasına yönlendir',\n                            },\n                        ]",
                              },
                            ],
                            attrs: {
                              placeholder:
                                "Kullanıcı destek isterse +1 (925) 222-2222 numarasına yönlendir; satış ekibine ulaşmak isterse +1 (925) 333-3333 numarasına yönlendir",
                              rows: 3,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "hint-text" }, [
                            _vm._v(
                              "Use a prompt to handle dynamic call transfer routing."
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Type" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "transfer_type",
                                {
                                  initialValue: "cold",
                                },
                              ],
                              expression:
                                "[\n                            'transfer_type',\n                            {\n                                initialValue: 'cold',\n                            },\n                        ]",
                            },
                          ],
                          on: { change: _vm.onWarmTransferChange },
                        },
                        [
                          _c("a-radio", { attrs: { value: "cold" } }, [
                            _vm._v("Cold Transfer"),
                          ]),
                          _vm._v(" "),
                          _c("a-radio", { attrs: { value: "warm" } }, [
                            _vm._v("Warm Transfer"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm.transferCallForm.getFieldValue("transfer_type") ===
                        "cold"
                          ? _c("div", [
                              _vm._v(
                                "\n                            AI transfers the call to the next agent without a debrief.\n                        "
                              ),
                            ])
                          : _c("div", [
                              _vm._v("AI provides a debrief to the next agent"),
                            ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.transferCallForm.getFieldValue("transfer_type") === "warm"
                    ? _c(
                        "a-form-item",
                        { attrs: { label: "Warm Transfer Message" } },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "warm_transfer_message",
                                  {
                                    rules: [
                                      {
                                        required:
                                          _vm.transferCallForm.getFieldValue(
                                            "transfer_type"
                                          ) === "warm",
                                        message:
                                          "Warm transfer mesajı gereklidir!",
                                      },
                                    ],
                                    initialValue:
                                      "Müşteri şu konuda yardım istiyor...",
                                  },
                                ],
                                expression:
                                  "[\n                            'warm_transfer_message',\n                            {\n                                rules: [\n                                    {\n                                        required: transferCallForm.getFieldValue('transfer_type') === 'warm',\n                                        message: 'Warm transfer mesajı gereklidir!',\n                                    },\n                                ],\n                                initialValue: 'Müşteri şu konuda yardım istiyor...',\n                            },\n                        ]",
                              },
                            ],
                            attrs: {
                              placeholder:
                                "Müşteri şu konuda yardım istiyor...",
                              rows: 2,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "hint-text" }, [
                            _vm._v(
                              "Çağrı aktarılırken karşı tarafa iletilecek kısa bilgilendirme"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Displayed Phone Number" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "display_number",
                                {
                                  initialValue: false,
                                },
                              ],
                              expression:
                                "[\n                            'display_number',\n                            {\n                                initialValue: false,\n                            },\n                        ]",
                            },
                          ],
                        },
                        [
                          _c("a-radio", { attrs: { value: false } }, [
                            _vm._v("Supsis Agent's Number"),
                          ]),
                          _vm._v(" "),
                          _c("a-radio", { attrs: { value: true } }, [
                            _vm._v("Transferee's Number"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        !_vm.transferCallForm.getFieldValue("display_number")
                          ? _c("div", [
                              _vm._v(
                                "\n                            Arayan numara olarak Supsis Agent numarası gösterilir\n                        "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(
                                "\n                            Original Caller or Callee. Özel telefon kullanıyorsanız, SIP REFER ve PSTN transferini\n                            etkinleştirin ve arayan numarasını göstermek için SIP REFER ayarlayın.\n                        "
                              ),
                            ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Custom SIP Headers" } },
                    [
                      _c(
                        "div",
                        { staticClass: "key-value-editor" },
                        [
                          _vm._l(
                            _vm.transferCallHeaders,
                            function (header, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "key-value-row" },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "40%" },
                                    attrs: {
                                      placeholder:
                                        "Header adı (örn: X-Custom-Header)",
                                    },
                                    model: {
                                      value: header.key,
                                      callback: function ($$v) {
                                        _vm.$set(header, "key", $$v)
                                      },
                                      expression: "header.key",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticStyle: { width: "50%" },
                                    attrs: {
                                      placeholder:
                                        "Header değeri (örn: Custom Value)",
                                    },
                                    model: {
                                      value: header.value,
                                      callback: function ($$v) {
                                        _vm.$set(header, "value", $$v)
                                      },
                                      expression: "header.value",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-button", {
                                    staticStyle: { width: "8%" },
                                    attrs: { type: "danger", icon: "delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeTransferCallHeader(
                                          index
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "dashed", block: "" },
                              on: { click: _vm.addTransferCallHeader },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(" Header Ekle\n                        "),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Add key/value pairs for call routing, metadata, or carrier integration.\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeTransferCallModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: _vm.transferCallSubmitting,
                              },
                              on: { click: _vm.handleTransferCallSubmit },
                            },
                            [
                              _vm.transferCallSubmitting
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v("autorenew")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                            Kaydet\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Press Digit Fonksiyonu", footer: null },
          on: { cancel: _vm.closePressDigitModal },
          model: {
            value: _vm.showPressDigitModal,
            callback: function ($$v) {
              _vm.showPressDigitModal = $$v
            },
            expression: "showPressDigitModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "press-digit-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.pressDigitForm, layout: "vertical" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "press_digit" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description (Opsiyonel)" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                initialValue:
                                  "Navigate through IVR menu by pressing specific digit(s).",
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                initialValue: 'Navigate through IVR menu by pressing specific digit(s).',\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Fonksiyonun ne yaptığını ve ne zaman çağrılacağını tanımlayın",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Pause Detection Delay (ms)" } },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "pause_detection_delay",
                              {
                                initialValue: 1000,
                              },
                            ],
                            expression:
                              "[\n                            'pause_detection_delay',\n                            {\n                                initialValue: 1000,\n                            },\n                        ]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, step: 100, placeholder: "1000" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "Fonksiyon çağrıldığında ajanın bekleyeceği süre (milisaniye)"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closePressDigitModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: _vm.pressDigitSubmitting,
                              },
                              on: { click: _vm.handlePressDigitSubmit },
                            },
                            [
                              _vm.pressDigitSubmitting
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v("autorenew")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                            Kaydet\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Custom Function", footer: null, width: "800px" },
          on: { cancel: _vm.closeCustomFunctionModal },
          model: {
            value: _vm.showCustomFunctionModal,
            callback: function ($$v) {
              _vm.showCustomFunctionModal = $$v
            },
            expression: "showCustomFunctionModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "custom-function-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.customFunctionForm, layout: "vertical" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "check_availability" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "Açıklama gereklidir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                rules: [{ required: true, message: 'Açıklama gereklidir!' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Fonksiyonun ne yaptığını ve ne zaman çağrılacağını tanımlayın",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-form-item", { attrs: { label: "HTTP Method & URL" } }, [
                    _c(
                      "div",
                      { staticClass: "url-input-group" },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "method",
                                  {
                                    initialValue: "POST",
                                  },
                                ],
                                expression:
                                  "[\n                                'method',\n                                {\n                                    initialValue: 'POST',\n                                },\n                            ]",
                              },
                            ],
                            staticStyle: { width: "120px" },
                          },
                          [
                            _c("a-select-option", { attrs: { value: "GET" } }, [
                              _vm._v("GET"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "POST" } },
                              [_vm._v("POST")]
                            ),
                            _vm._v(" "),
                            _c("a-select-option", { attrs: { value: "PUT" } }, [
                              _vm._v("PUT"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "PATCH" } },
                              [_vm._v("PATCH")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "DELETE" } },
                              [_vm._v("DELETE")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "url",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "URL gereklidir!",
                                    },
                                    {
                                      type: "url",
                                      message: "Geçerli bir URL girin!",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "[\n                                'url',\n                                {\n                                    rules: [\n                                        { required: true, message: 'URL gereklidir!' },\n                                        { type: 'url', message: 'Geçerli bir URL girin!' },\n                                    ],\n                                },\n                            ]",
                            },
                          ],
                          attrs: {
                            placeholder: "https://api.example.com/function",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.showWebhookAutomationSelector },
                          },
                          [
                            _c("AutomationIcon", {
                              tag: "component",
                              staticClass: "myIcon",
                              style: {
                                fill: "var(--color-icon-primary-default)",
                              },
                            }),
                            _vm._v(
                              "\n                            Supsis Otomasyon'dan Seç\n                        "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedAutomation
                      ? _c("div", { staticClass: "selected-automation" }, [
                          _c(
                            "div",
                            { staticClass: "automation-info" },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("link"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("Bağlı Otomasyon: "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.selectedAutomation.name)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToAutomationDetail(
                                        _vm.selectedAutomation.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("open_in_new"),
                                  ]),
                                  _vm._v(
                                    " Düzenle\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Headers (Opsiyonel)" } },
                    [
                      _c(
                        "div",
                        { staticClass: "key-value-editor" },
                        [
                          _vm._l(
                            _vm.customFunctionHeaders,
                            function (header, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "key-value-row" },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "40%" },
                                    attrs: {
                                      placeholder:
                                        "Header adı (örn: Authorization)",
                                    },
                                    model: {
                                      value: header.key,
                                      callback: function ($$v) {
                                        _vm.$set(header, "key", $$v)
                                      },
                                      expression: "header.key",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticStyle: { width: "50%" },
                                    attrs: {
                                      placeholder:
                                        "Header değeri (örn: Bearer token123)",
                                    },
                                    model: {
                                      value: header.value,
                                      callback: function ($$v) {
                                        _vm.$set(header, "value", $$v)
                                      },
                                      expression: "header.value",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-button", {
                                    staticStyle: { width: "8%" },
                                    attrs: { type: "danger", icon: "delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeHeader(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "dashed", block: "" },
                              on: { click: _vm.addHeader },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(" Header Ekle\n                        "),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "API isteğine eklenecek HTTP header'ları (örn: Authorization, Content-Type)"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Query Parameters (Opsiyonel)" } },
                    [
                      _c(
                        "div",
                        { staticClass: "key-value-editor" },
                        [
                          _vm._l(
                            _vm.customFunctionQueryParams,
                            function (param, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "key-value-row" },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "40%" },
                                    attrs: {
                                      placeholder: "Parametre adı (örn: page)",
                                    },
                                    model: {
                                      value: param.key,
                                      callback: function ($$v) {
                                        _vm.$set(param, "key", $$v)
                                      },
                                      expression: "param.key",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticStyle: { width: "50%" },
                                    attrs: {
                                      placeholder: "Parametre değeri (örn: 1)",
                                    },
                                    model: {
                                      value: param.value,
                                      callback: function ($$v) {
                                        _vm.$set(param, "value", $$v)
                                      },
                                      expression: "param.value",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-button", {
                                    staticStyle: { width: "8%" },
                                    attrs: { type: "danger", icon: "delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeQueryParam(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "dashed", block: "" },
                              on: { click: _vm.addQueryParam },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                " Query Parameter Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "URL'ye eklenecek query parametreleri (örn: ?page=1&sort=asc)"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Response Variables (Opsiyonel)" } },
                    [
                      _c(
                        "div",
                        { staticClass: "key-value-editor" },
                        [
                          _vm._l(
                            _vm.customFunctionResponseVariables,
                            function (variable, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "key-value-row" },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "40%" },
                                    attrs: {
                                      placeholder:
                                        "Değişken adı (örn: user_name)",
                                    },
                                    model: {
                                      value: variable.key,
                                      callback: function ($$v) {
                                        _vm.$set(variable, "key", $$v)
                                      },
                                      expression: "variable.key",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticStyle: { width: "50%" },
                                    attrs: {
                                      placeholder:
                                        "JSON path (örn: data.user.name)",
                                    },
                                    model: {
                                      value: variable.value,
                                      callback: function ($$v) {
                                        _vm.$set(variable, "value", $$v)
                                      },
                                      expression: "variable.value",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-button", {
                                    staticStyle: { width: "8%" },
                                    attrs: { type: "danger", icon: "delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeResponseVariable(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "dashed", block: "" },
                              on: { click: _vm.addResponseVariable },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                " Response Variable Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "API yanıtından çıkarılacak değişkenler (örn: user_name → data.user.name)"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "API Timeout (ms)" } },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "timeout_ms",
                              {
                                initialValue: 60000,
                              },
                            ],
                            expression:
                              "[\n                            'timeout_ms',\n                            {\n                                initialValue: 60000,\n                            },\n                        ]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 1000, max: 600000, step: 1000 },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "API çağrısının zamanaşımı süresi (1.000-600.000 ms arası)"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            [
                              _c(
                                "a-checkbox",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "speak_during_execution",
                                        {
                                          valuePropName: "checked",
                                          initialValue: true,
                                        },
                                      ],
                                      expression:
                                        "[\n                                    'speak_during_execution',\n                                    {\n                                        valuePropName: 'checked',\n                                        initialValue: true,\n                                    },\n                                ]",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n                                İşlem Sırasında Konuş\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "hint-text" }, [
                                _vm._v(
                                  '\n                                İşlem sırasında ajanın "Bir saniye, kontrol ediyorum" gibi cümleler söylemesine izin\n                                verir\n                            '
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            [
                              _c(
                                "a-checkbox",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "speak_after_execution",
                                        {
                                          valuePropName: "checked",
                                          initialValue: true,
                                        },
                                      ],
                                      expression:
                                        "[\n                                    'speak_after_execution',\n                                    {\n                                        valuePropName: 'checked',\n                                        initialValue: true,\n                                    },\n                                ]",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n                                İşlem Sonrası Konuş\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "hint-text" }, [
                                _vm._v(
                                  "\n                                İşlem sonuçlandığında ajanın sonucu kullanıcıya bildirmesine izin verir\n                            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.customFunctionForm.getFieldValue("speak_during_execution")
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label:
                              "İşlem Sırasında Konuşma Açıklaması (Opsiyonel)",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["execution_message_description", {}],
                                expression:
                                  "['execution_message_description', {}]",
                              },
                            ],
                            attrs: {
                              placeholder:
                                "Ajanın işlem sırasında ne söyleyeceğine dair açıklama veya örnekler",
                              rows: 2,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "hint-text" }, [
                            _vm._v(
                              'Sadece "İşlem Sırasında Konuş" aktifse kullanılır'
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Parameters (JSON Schema)" } },
                    [
                      _c("div", { staticClass: "parameters-toolbar" }, [
                        _c(
                          "div",
                          { staticClass: "sample-buttons" },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.applySampleParameters(1)
                                  },
                                },
                              },
                              [_vm._v("Randevu Örneği")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.applySampleParameters(2)
                                  },
                                },
                              },
                              [_vm._v("Sipariş Örneği")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.applySampleParameters(3)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "Kullanıcı Bilgisi Örneği\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "parameters",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "Parametreler gereklidir!",
                                  },
                                  { validator: _vm.validateParameters },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'parameters',\n                            {\n                                rules: [\n                                    { required: true, message: 'Parametreler gereklidir!' },\n                                    { validator: validateParameters },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: "JSON Schema formatında parametreler",
                          rows: 10,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Bu fonksiyona geçirilecek parametrelerin JSON Schema formatında tanımı\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeCustomFunctionModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: {
                            primary: "",
                            disabled: _vm.customFunctionSubmitting,
                          },
                          on: { click: _vm.handleCustomFunctionSubmit },
                        },
                        [
                          _vm.customFunctionSubmitting
                            ? _c("i", { staticClass: "material-icons spin" }, [
                                _vm._v("autorenew"),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                        Kaydet\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Extract Dynamic Variable",
            footer: null,
            width: "800px",
          },
          on: { cancel: _vm.closeExtractDynamicVariableModal },
          model: {
            value: _vm.showExtractDynamicVariableModal,
            callback: function ($$v) {
              _vm.showExtractDynamicVariableModal = $$v
            },
            expression: "showExtractDynamicVariableModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "extract-dynamic-variable-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: {
                    form: _vm.extractDynamicVariableForm,
                    layout: "vertical",
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Function Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                initialValue: "extract_user_details",
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                initialValue: 'extract_user_details',\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "extract_user_details" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                initialValue:
                                  "Extract the user's details like name, email, age, etc. from the conversation",
                                rules: [
                                  {
                                    required: true,
                                    message: "Açıklama gereklidir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                initialValue: 'Extract the user\\'s details like name, email, age, etc. from the conversation',\n                                rules: [{ required: true, message: 'Açıklama gereklidir!' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Extract the user's details like name, email, age, etc. from the conversation",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-form-item", { attrs: { label: "Variables" } }, [
                    _c(
                      "div",
                      { staticClass: "variables-list" },
                      [
                        _vm._l(
                          _vm.extractDynamicVariables,
                          function (variable, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "variable-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "variable-header" },
                                  [
                                    _c("h5", [
                                      _vm._v("Variable " + _vm._s(index + 1)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "small",
                                          icon: "delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeExtractVariable(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Sil\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-row",
                                  { attrs: { gutter: 16 } },
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          { attrs: { label: "Type" } },
                                          [
                                            _c(
                                              "a-select",
                                              {
                                                attrs: {
                                                  placeholder: "Seçiniz",
                                                },
                                                model: {
                                                  value: variable.type,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      variable,
                                                      "type",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "variable.type",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: { value: "string" },
                                                  },
                                                  [_vm._v("String")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          { attrs: { label: "Name" } },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder: "customer_name",
                                              },
                                              model: {
                                                value: variable.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    variable,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "variable.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "Description" } },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder:
                                          "The name of the customer.",
                                      },
                                      model: {
                                        value: variable.description,
                                        callback: function ($$v) {
                                          _vm.$set(variable, "description", $$v)
                                        },
                                        expression: "variable.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "Examples (virgülle ayırın)",
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: "John Doe, Jane Smith",
                                      },
                                      model: {
                                        value: variable.examplesText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            variable,
                                            "examplesText",
                                            $$v
                                          )
                                        },
                                        expression: "variable.examplesText",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "hint-text" }, [
                                      _vm._v(
                                        "Modele stil ve sözdizimi öğretmek için örnek değerler"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "dashed", block: "" },
                            on: { click: _vm.addExtractVariable },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" Variable Ekle\n                        "),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeExtractDynamicVariableModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: _vm.extractDynamicVariableSubmitting,
                              },
                              on: {
                                click: _vm.handleExtractDynamicVariableSubmit,
                              },
                            },
                            [
                              _vm.extractDynamicVariableSubmitting
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v("autorenew")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                            Kaydet\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Agent Transfer", footer: null, width: "800px" },
          on: { cancel: _vm.closeAgentSwapModal },
          model: {
            value: _vm.showAgentSwapModal,
            callback: function ($$v) {
              _vm.showAgentSwapModal = $$v
            },
            expression: "showAgentSwapModal",
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "agent-swap-modal-wrapper" } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.agentSwapForm, layout: "vertical" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Function Name" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                initialValue: "agent_transfer",
                                rules: [
                                  {
                                    required: true,
                                    message: "İsim gereklidir!",
                                  },
                                  {
                                    pattern: /^[a-zA-Z0-9_-]+$/,
                                    message:
                                      "Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'name',\n                            {\n                                initialValue: 'agent_transfer',\n                                rules: [\n                                    { required: true, message: 'İsim gereklidir!' },\n                                    {\n                                        pattern: /^[a-zA-Z0-9_-]+$/,\n                                        message:\n                                            'Sadece alfanumerik, alt çizgi ve tire karakterleri kullanılabilir!',\n                                    },\n                                ],\n                            },\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "agent_transfer" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Fonksiyon adı benzersiz olmalıdır, a-z, A-Z, 0-9, _ veya - karakterlerinden oluşabilir\n                        (boşluk olmadan)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Description" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              {
                                initialValue:
                                  "Transfer the call to the customer service agent",
                                rules: [
                                  {
                                    required: true,
                                    message: "Açıklama gereklidir!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'description',\n                            {\n                                initialValue: 'Transfer the call to the customer service agent',\n                                rules: [{ required: true, message: 'Açıklama gereklidir!' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder:
                            "Transfer the call to the customer service agent",
                          rows: 3,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Select Agent", required: "" } },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "agent_id",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Ajan seçilmelidir!",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "[\n                            'agent_id',\n                            {\n                                rules: [{ required: true, message: 'Ajan seçilmelidir!' }],\n                            },\n                        ]",
                            },
                          ],
                          attrs: {
                            placeholder: "Bir ajan seçin",
                            "show-search": "",
                            "filter-option": _vm.filterAgentOption,
                          },
                        },
                        _vm._l(_vm.availableAgents, function (ag) {
                          return _c(
                            "a-select-option",
                            { key: ag.agent_id, attrs: { value: ag.agent_id } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(ag.agent_name) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Post Call Analysis Setting" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "post_call_analysis_setting",
                                {
                                  initialValue: "only_destination_agent",
                                },
                              ],
                              expression:
                                "[\n                            'post_call_analysis_setting',\n                            {\n                                initialValue: 'only_destination_agent',\n                            },\n                        ]",
                            },
                          ],
                        },
                        [
                          _c("a-radio", { attrs: { value: "both_agents" } }, [
                            _vm._v("Both Agents"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-radio",
                            { attrs: { value: "only_destination_agent" } },
                            [_vm._v("Only Destination Agent")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Hangi ajanın analiz alanlarının çağrı geçmişine dahil edileceğini seçin\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Webhook Setting" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "webhook_setting",
                                {
                                  initialValue: "only_source_agent",
                                },
                              ],
                              expression:
                                "[\n                            'webhook_setting',\n                            {\n                                initialValue: 'only_source_agent',\n                            },\n                        ]",
                            },
                          ],
                        },
                        [
                          _c("a-radio", { attrs: { value: "both_agents" } }, [
                            _vm._v("Both Agents"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-radio",
                            { attrs: { value: "only_destination_agent" } },
                            [_vm._v("Only Destination Agent")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-radio",
                            { attrs: { value: "only_source_agent" } },
                            [_vm._v("Only Source Agent")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          "\n                        Çağrı güncellemeleri göndermek için hangi ajanın webhook endpoint'inin kullanılacağını seçin\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-checkbox",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "speak_during_execution",
                                {
                                  valuePropName: "checked",
                                  initialValue: false,
                                },
                              ],
                              expression:
                                "[\n                            'speak_during_execution',\n                            {\n                                valuePropName: 'checked',\n                                initialValue: false,\n                            },\n                        ]",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n                        İşlem Sırasında Konuş\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hint-text" }, [
                        _vm._v(
                          '\n                        Fonksiyon 2 saniyeden uzun sürerse, ajan "Bunu kontrol etmeme izin ver" gibi bir şey söyleyebilir\n                    '
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.agentSwapForm.getFieldValue("speak_during_execution")
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "İşlem Sırasında Konuşma Açıklaması",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["execution_message_description", {}],
                                expression:
                                  "['execution_message_description', {}]",
                              },
                            ],
                            attrs: {
                              placeholder:
                                "Ajanın işlem sırasında ne söyleyeceğine dair açıklama",
                              rows: 2,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "hint-text" }, [
                            _vm._v(
                              'Sadece "İşlem Sırasında Konuş" aktifse kullanılır'
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeAgentSwapModal } },
                        [_vm._v("İptal")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: _vm.agentSwapSubmitting,
                              },
                              on: { click: _vm.handleAgentSwapSubmit },
                            },
                            [
                              _vm.agentSwapSubmitting
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v("autorenew")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                            Kaydet\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Webhook Otomasyonları",
            footer: null,
            width: "800px",
          },
          on: { cancel: _vm.closeWebhookAutomationSelectorModal },
          model: {
            value: _vm.showWebhookAutomationSelectorModal,
            callback: function ($$v) {
              _vm.showWebhookAutomationSelectorModal = $$v
            },
            expression: "showWebhookAutomationSelectorModal",
          },
        },
        [
          _c("a-spin", { attrs: { spinning: _vm.webhookAutomationLoading } }, [
            _c(
              "div",
              { staticClass: "webhook-automation-list" },
              [
                _c("div", { staticClass: "webhook-header" }, [
                  _c("h4", [_vm._v("Webhook Otomasyonları")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-input" },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "Arama" },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.filteredWebhookAutomations.length > 0
                  ? _c("SupsisTable", {
                      attrs: {
                        columns: _vm.webhookAutomationColumns,
                        rows: _vm.filteredWebhookAutomations,
                        options: {},
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectWebhookAutomation(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Seç\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3235974069
                      ),
                    })
                  : _c(
                      "div",
                      { staticClass: "no-webhooks" },
                      [
                        _c(
                          "a-empty",
                          {
                            attrs: {
                              description: "Webhook otomasyonu bulunamadı",
                            },
                          },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.goToAutomations },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "margin-right": "4px",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v("add")]
                                ),
                                _vm._v(
                                  "\n                            Yeni Webhook Otomasyonu Oluştur\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }